import React from 'react';

/**
 * FormSubmitButton
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FormSubmitButton = (props) => {
    const {
        label,
        className,
        onClick,
        type = "submit",
        disabled = false,
        btnClassName = `btn-primary m-t-30`
    } = props;

    return (
        <div className={className}>
            <button
                className={`btn ${btnClassName}`}
                type={type}
                onClick={onClick}
                disabled={(disabled) ? 'disabled' : ''}
            >
                {label}
            </button>
        </div>
    );
}

export default React.memo(FormSubmitButton);
